// api.js
import axios from 'axios';
import constants from './Constants';
import { useNavigate } from 'react-router-dom';

const useAxios = () => {

  const navigation = useNavigate();

  const instance = axios.create({
    headers: {
      'Content-Type': 'application/json',
      'Accept-Version': constants.acceptVersion,
      'Role': 'customer',
      'Platform': 'BlockMap',
      'App-Version': constants.appVersion,
    }
  });

  instance.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const errors = error?.response?.data?.errors || [];
      for (let error of errors) {
        if (error?.path == 'api_key' || error?.path == 'email') {
          constants.showToast('error', 'Unauthorized', 'Whoopty Doo! Unauthorized access detected, please sign in again');
          await constants.clearData();
          navigation('/auth/sign-in');
          return Promise.reject(error);
        }
        constants.showToast('error', 'ERROR', error?.msg || 'Snap! An error occurred, please try again later');
      }
      if (error?.code === "ERR_NETWORK" || error?.code === "ERR_CANCELED") {
        await constants.clearData();
        navigation('/auth/sign-in');
      }
      if (error.response?.status === 429) {
        constants.showToast('error', 'ERROR', error?.response?.data || 'Snap! Too many requests, Try again later');
      }
      if (error.response?.status === 401 || error.response?.status === 409) {
        constants.showToast('error', 'Unauthorized', 'Whoopty Doo! Unauthorized access detected, please sign in again');
        await constants.clearData();
        navigation('/auth/sign-in');
      }
      if (error.response?.status === 400 && !(await isAuthenticated())) {
        constants.showToast('error', 'Unauthorized', 'Whoopty Doo! Unauthorized access detected, please sign in again');
        await constants.clearData();
        navigation('/auth/sign-in');
      }
      if (!(await isAuthenticated())) {
        constants.showToast('error', 'Unauthorized', 'Whoopty Doo! Unauthorized access detected, please sign in again');
        await constants.clearData();
        navigation('/auth/sign-in');
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

// Check if user is authenticated
async function isAuthenticated() {
  const API_KEY = await constants.getData('API_KEY');
  const EMAIL = await constants.getData('EMAIL');
  if (!API_KEY || !EMAIL) {
    return false;
  }
  return true;
}

export default useAxios;